package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

@Composable
fun MixRankForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "I couldn't care less about what title the role carries. Give me challenging work and I am off to build.",
        "Self-built datacenters, own distributed file system, petabytes of data - I want a bite of that.",
        "I've spent my career becoming whatever the problem needed, and I'd rather be trusted to learn than hired for a keyword.",
        "So, Rust and PostgreSQL aren't where I'll push commits from day one, but where you'll find me asking a thoughtful question by the end of the week.",
    )
}
